/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedHeadTitleTag_metadata = {
    readonly title: string | null;
    readonly " $refType": "SharedHeadTitleTag_metadata";
};
export type SharedHeadTitleTag_metadata$data = SharedHeadTitleTag_metadata;
export type SharedHeadTitleTag_metadata$key = {
    readonly " $data"?: SharedHeadTitleTag_metadata$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedHeadTitleTag_metadata">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedHeadTitleTag_metadata",
  "type": "MetaData",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'ecdf49ebde8460cdcb8f117d80dc9a0e';
export default node;
